import register from '../../../../global/js/registry';
export default register('m-job-offer-search', () => import(/* webpackMode: "lazy" */ './m-job-offer-search.controller'));
